import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
/**
 * Default display labels for the Order Payment Form component.
 */
export const defaultOrderPaymentFormDisplayText = {
    completeOrderButtonLabel: 'Complete order',
    maskedGiftCardNumberFormat: 'Gift card: ${maskedCardNumber}',
    memberBalancePaymentFormat: '${balanceTypeName}: ${units}',
    failedToRemoveGiftCardErrorMessage: 'Failed to remove gift card: ${maskedCardNumber}. Please try again.',
    failedToRemoveMemberBalancePaymentErrorMessage: 'Failed to remove payment of ${units}. Please try again.',
    costRemainingLabel: 'Remaining',
    paymentButtonLabel: 'Pay now',
    paymentMethodsHeading: 'Your payment options',
    paymentFailedTitle: 'Sorry, something went wrong.',
    paymentFailedMessage: 'Refresh your browser to try loading this payment method again.',
    orderCompletionFailedTitle: 'Sorry, something went wrong.',
    orderCompletionFailedMessage: 'Please contact cinema support for assistance.',
    failedToInitialiseConnectorTitle: 'Sorry, something went wrong.',
    failedToInitialiseConnectorMessage: 'Refresh your browser to try loading this payment method again.',
    failedToLoadDataTitle: 'Sorry, something went wrong.',
    failedToLoadDataMessage: 'Refresh your browser to try loading the payment form again.',
    paymentDeclinedTitle: 'Sorry, your payment was declined.',
    paymentDeclinedMessage: 'Please check if you have sufficient funds to complete the payment or try a different payment method.',
    processingPaymentMessage: 'Processing payment',
    paymentDeclinedTryAgainButtonLabel: 'Try again'
};
export const orderPaymentFormDisplayTextValidator = Validator.object({
    completeOrderButtonLabel: nonEmptyStringValidator,
    maskedGiftCardNumberFormat: nonEmptyStringValidator,
    memberBalancePaymentFormat: nonEmptyStringValidator,
    failedToRemoveGiftCardErrorMessage: nonEmptyStringValidator,
    failedToRemoveMemberBalancePaymentErrorMessage: nonEmptyStringValidator,
    costRemainingLabel: nonEmptyStringValidator,
    paymentButtonLabel: nonEmptyStringValidator,
    paymentMethodsHeading: nonEmptyStringValidator,
    orderCompletionFailedTitle: nonEmptyStringValidator,
    orderCompletionFailedMessage: nonEmptyStringValidator,
    paymentFailedTitle: nonEmptyStringValidator,
    paymentFailedMessage: nonEmptyStringValidator,
    failedToInitialiseConnectorTitle: nonEmptyStringValidator,
    failedToInitialiseConnectorMessage: nonEmptyStringValidator,
    failedToLoadDataTitle: nonEmptyStringValidator,
    failedToLoadDataMessage: nonEmptyStringValidator,
    paymentDeclinedTitle: nonEmptyStringValidator,
    paymentDeclinedMessage: nonEmptyStringValidator,
    processingPaymentMessage: nonEmptyStringValidator,
    paymentDeclinedTryAgainButtonLabel: nonEmptyStringValidator
});
